import { render } from "./comment-list.vue?vue&type=template&id=4e9cd07d&scoped=true"
import script from "./comment-list.vue?vue&type=script&lang=js"
export * from "./comment-list.vue?vue&type=script&lang=js"

import "./comment-list.vue?vue&type=style&index=0&id=4e9cd07d&scoped=true&lang=less"

import exportComponent from "/home/www/jenkins/jenkins_home/workspace/yizhige_production/yizhige_admin_pro/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e9cd07d"]])

export default __exports__